export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const THEME_KEY = 'theme-preference';
